import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { Type, Hash, ToggleRight, Braces, Brackets } from 'lucide-react';

const dataTypeIcons = {
  string: <Type size={14} className="mr-1.5 flex-shrink-0 opacity-80" />,
  number: <Hash size={14} className="mr-1.5 flex-shrink-0 opacity-80" />,
  boolean: (
    <ToggleRight size={14} className="mr-1.5 flex-shrink-0 opacity-80" />
  ),
  object: <Braces size={14} className="mr-1.5 flex-shrink-0 opacity-80" />,
  array: <Brackets size={14} className="mr-1.5 flex-shrink-0 opacity-80" />,
};

const VariablePill = ({ node }) => {
  const { display, dataType } = node.attrs;
  const icon = dataTypeIcons[dataType?.toLowerCase()] || dataTypeIcons.string;

  return (
    <NodeViewWrapper
      as="span"
      // ⭐ THE FIX: Adjusted padding, using a border, and ensuring vertical alignment.
      className="mx-0.5 inline-flex select-none items-center rounded-md border border-indigo-500/50 bg-indigo-500/30 px-2 py-0 align-middle font-mono text-sm text-indigo-300"
    >
      {icon}
      <span className="truncate">{display}</span>
    </NodeViewWrapper>
  );
};

export default VariablePill;
